import ACL_RELATIONSHIPS from "acl-relationships";

// The leads table is scoped to its owning campaign. The shared components
// select the ACL block (and the owner label) by scope; the polymorphic scope
// map leaves room for a future owner type without a component refactor.
const SCOPE = {
  campaign: { acl: ACL_RELATIONSHIPS.campaignLead, label: "campaign" },
};

export const leadAclForScope = scope => SCOPE[scope].acl;

export const ownerLabelForScope = scope => SCOPE[scope].label;
